/*
 * Copyright 2023, Corning Optical Communications
 * All Rights Reserved.
 */

import { AppState } from "../..";

// import { createSelector } from "@reduxjs/toolkit";

export const tasksSelector = (state: AppState) => state.tasks.scheduledtask;
export const activeTaskStepsSelector = (state: AppState) => state.tasks.activeTaskStep;
export const isEditTaskSelector = (state: AppState) => state.tasks.isEditTask;
export const selectedTaskSelector = (state: AppState) => state.tasks.selectedTask;
export const isTemplateSelector = (state: AppState) => state.tasks.selectedTemplate;
